import React from 'react';
import SystemVariablesList from './list';
import SystemVariablesEdit from './edit';

const SystemVariablesTitle = ({ record }) => {
    return <span> Editando {record ? `"${record.name}"` : ''}</span>;
};

export { SystemVariablesTitle, SystemVariablesList, SystemVariablesEdit };